import { createModel } from '@/store/tools';

const model = {
    namespace: 'serviceorder',
    build: (T, A, S, R, C) => ({
        actiontypes: {
            'getOrderCommonList': T('getOrderCommonList'), // 获取增值服务订单列表
            'getOrderCommonDetail': T('getOrderCommonDetail'), // 获取增值服务订单详情
            'getBrokerReferrerRoleEnum': T('getBrokerReferrerRoleEnum'), // 获取推广类型
            'getOrderStatusEnum': T('getOrderStatusEnum'), // 获取状态
        },
        actions: {
             'getOrderCommonList': A('getOrderCommonList'), // 获取增值服务订单列表
             'getOrderCommonDetail': A('getOrderCommonDetail'), // 获取增值服务订单详情
             'getCleanDetail': C('getOrderCommonDetail'), // 管理清除详情数据
             'getBrokerReferrerRoleEnum': A('getBrokerReferrerRoleEnum'), // 获取推广类型
             'getOrderStatusEnum': A('getOrderStatusEnum'), // 获取状态
        },
        sagas: {
            'getOrderCommonList': S('getOrderCommonList', '/?cmd=com.xqxc.api.pig.mis.order.OrderCommonManageMisService.getOrderCommonList'),
            'getOrderCommonDetail': S('getOrderCommonDetail', '/?cmd=com.xqxc.api.pig.mis.order.OrderCommonManageMisService.getOrderCommonDetail'),
            'getBrokerReferrerRoleEnum': S('getBrokerReferrerRoleEnum', '/?cmd=com.xqxc.api.pig.mis.biz.platform.PfEnumMisService.getEnum'),
            'getOrderStatusEnum': S('getOrderStatusEnum', '/?cmd=com.xqxc.api.pig.mis.biz.platform.PfEnumMisService.getEnum'),
        },
        reducers: {
            'OrderCommonList': R('getOrderCommonList', { dataList: [], pageNum: 1, pageSize: 25, resultTotal: 0 }),
            'OrderCommonDetail': R('getOrderCommonDetail', {}),
            'BrokerReferrerRoleEnum': R('getBrokerReferrerRoleEnum', []),
            'OrderStatusEnum': R('getOrderStatusEnum', []),
        }
    })
};
export default createModel(model);